import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { Link } from "react-router";

import ReadBimClassName from "./ReadBimClassName.graphql";
import { TAXONOMY_BASE } from "../../../../../constants";

export default function BimClassLink(props) {
    const { id } = props;

    const readBimClass = useQuery(
        gql(ReadBimClassName),
        {
            variables: {
                id,
            },
        },
    );

    if (readBimClass.loading || readBimClass.error || !readBimClass.data?.bimClass) return null;

    const nameText = readBimClass.data.bimClass.data?.name?.[0]?.text ?? id;

    return (
        <Link to={ `${ TAXONOMY_BASE }/BimClasses/${ id }` }>
            { nameText }
        </Link>
    );
}
